<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">
      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            Employee Bank/PF/ESI
            <br />
          </h5>
          <br />
        </div>
        <!-- /Title -->
        <!-- Breadcrumb -->
        <div class="col-lg-8 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Employee</li>
            <li>Information</li>
            <li class="active">Employee Bank/PF/ESI</li>
          </ol>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-6">
                    <autocomplete
                      :search="search"
                      placeholder="Search employee"
                      aria-label="Search employee"
                      :get-result-value="getResultValue"
                      @submit="handleSubmit"
                    ></autocomplete>
                  </div>
                </div>
              </div>
              <u>{{ form.full_name }}</u>
              <br /><br />
            </div>
          </div>
        </div>
      </div>

      <!-- Row -->
      <div class="row">
        <div class="col-md-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="row">
                  <div class="col-sm-12 col-xs-12">
                    <div class="form-wrap form-horizontal">
                      <div class="row">
                        <div class="col-md-6">
                          <Bank
                            :isLoading="isLoading"
                            :form="form"
                            :banks="banks"
                            :accountTypes="accountTypes"
                            :paymentTypes="paymentTypes"
                            @update="update"
                          ></Bank>

                          <Esi
                            :isLoading="isLoading"
                            :form="form"
                            @update="update"
                          ></Esi>

                          <Leave :form="form" @update="update"></Leave>

                          <Bonus :form="form" @update="update"></Bonus>
                        </div>
                        <div class="col-md-6">
                          <Pf
                            :isLoading="isLoading"
                            :form="form"
                            @update="update"
                          ></Pf>

                          <Lwf :form="form" @update="update"></Lwf>

                          <Pt :form="form" @update="update"></Pt>
                        </div>
                      </div>
                    </div>

                    <router-link
                      to="/main/employees/passport-visa"
                      class="btn btn-primary"
                      >Next</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from "axios";
import store from "@/store";
import { updateFormData } from "@/static/helpers.js";
import Bank from "./bank.vue";
import Pf from "./pf.vue";
import Esi from "./esi.vue";
import Lwf from "./lwf.vue";
import Pt from "./pt.vue";
import Leave from "./leave.vue";
import Bonus from "./bonus.vue";

export default {
  name: "EmployeeBankPfEsi",
  data() {
    return {
      form: {},
      isLoading: false,
      addressTypes: [],
      banks: [],
      accountTypes: [],
      paymentTypes: [],
    };
  },
  components: {
    Bank,
    Pf,
    Esi,
    Lwf,
    Pt,
    Leave,
    Bonus,
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("users/masters");
      masters = masters.data;
      this.banks = masters.banks;
      masters.account_types.forEach((accountType) => {
        this.accountTypes.push({
          id: accountType.id,
          name: accountType.code,
          code: accountType.code,
        });
      });
      masters.payment_types.forEach((paymentType) => {
        this.paymentTypes.push({
          id: paymentType.id,
          name: paymentType.code,
          code: paymentType.code,
        });
      });
      masters.address_types.forEach((addressType) => {
        this.addressTypes.push({
          id: addressType.id,
          name: addressType.code,
          code: addressType.code,
        });
      });

      // Get Employee
      if (this.employee != null) {
        this.updateForm(this.employee);
      }
    },
    async search(input) {
      // if (input.length < 3) {
      //   return []
      // } else {
      let response = await axios.get(`/users?search=${input}`);
      return response.data.data;
      // }
    },
    getResultValue(result) {
      return result.full_name;
    },
    async handleSubmit(result) {
      let response = await axios.get(`users/${result.id}`);
      store.dispatch("employee/setEmployee", response.data.data);
      this.updateForm(response.data.data);
    },
    updateForm(formData) {
      this.form = updateFormData(formData, this.addressTypes, this.site);
    },
    async update() {
      try {
        this.isLoading = true;
        let response = await axios.post(`/users`, this.form);
        store.dispatch("employee/setEmployee", response.data.data);
        this.updateForm(response.data.data);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
